import { inject, Injectable } from '@angular/core';
import { take } from 'rxjs';
import { UserApiService } from '../api/user-api.service';
import { IUserInfo } from '../types/response/resUser';

@Injectable({
  providedIn: 'root'
})
export class UserCommonService {

  private userApi = inject(UserApiService)

  // 登录状态
  public LOGIN_STATUS: boolean = false
  // 登录验证码倒计时
  public loginCodeCountDown: number = 0
  // 用户信息（登录人员）
  public userInfo: IUserInfo | undefined
  // 联系人信息
  public contsInfo: IUserInfo[] | undefined
  // 当前对话联系人
  public curContact: IUserInfo | undefined
  // 登录用户id
  public uid: number = -1

  // 获取用户及其联系人信息
  public refreshUserInfo() {
    return new Promise<void>((resolve) => {
      this.userApi.getUserInfoAPI().pipe(take(1)).subscribe(res => {
        if (res && res.user_info) {
          this.userInfo = res.user_info
          this.uid = this.userInfo.id

          this.userApi.getUserAllContsInfoAPI().pipe(take(1)).subscribe(res => {
            if (res) {
              this.contsInfo = res

              // 如果当前小程序没有本人，将角色设置为第一个联系人
              if (!this.userInfo?.wx_user_id) {
                if (this.contsInfo.length) {
                  this.userInfo = this.contsInfo[0]
                  this.uid = this.userInfo.id
                }
              }

              resolve()
            }
          })
        }
      })
    })
  }

  // 切换联系人（传入cid时切换至指定id联系人，未传cid时切换至默认联系人）
  public switchCurContact(cid?: number) {
    const cont = this.contsInfo?.filter(contact => (cid ? (contact.id === cid) : contact.is_default))
    this.curContact = (cont?.length ? cont[0] : this.contsInfo![0])
  }

  // 返回默认联系人ID
  public curDefContId() {
    return this.contsInfo?.filter(cont => cont.is_default)[0]?.id ?? this.contsInfo?.[0]?.id ?? -1
  }

  // 调整指定联系人默认状态
  public changeContDefaultStatus(cid: number, status: boolean) {
    return new Promise<void>((resolve) => {
      this.userApi.updateUserInfoAPI({ user_id: cid, is_default: status })
        .pipe(take(1)).subscribe(res => { res && res === 'success' && resolve() })
    })
  }

  /*
    根据用户当前性别与关系返回身份
    1. 本人，男的返回husband，女的返回wife
    2. 老婆返回wife，老公返回husband
    3. 妈妈、爸爸、儿子、女儿、其他 返回对应的identity
  */
  public getUserIdentity(sex: 0 | 1 | 2, relation: string) {
    sex === 0 && (sex = 1)
    switch (relation) {
      case '本人':
      case '配偶':
        return sex === 1 ? 'husband' : 'wife'
      case '老公':
        return 'husband'
      case '老婆':
        return 'wife'
      case '父母':
        return sex === 1 ? 'father' : 'mother'
      case '爸爸':
        return 'father'
      case '妈妈':
        return 'mother'
      case '子女':
        return sex === 1 ? 'son' : 'daughter'
      case '儿子':
        return 'son'
      case '女儿':
        return 'daughter'
      default:
        return 'other-man'
    }
  }

  // 置空当前人员信息
  public resetUserInfo() {
    this.curContact = undefined
    this.userInfo = undefined
    this.contsInfo = []
  }

}
